export default __webpack_public_path__ + "static/media/header-product.432c6805.png";